import { Success as SuccessView } from '../../../../components/Checkout/Success';
import { useCheckoutCtx } from '../../../../providers/CheckoutProvider';

export const Success = () => {
  const {
    artistName,
    identityVerificationRequired,
    isAuction,
    isPreOrderFlow,
    maxQuantity,
    orderedItems,
    redirectReturn,
  } = useCheckoutCtx();

  return (
    <SuccessView
      artistName={artistName}
      identityVerificationRequired={identityVerificationRequired}
      images={orderedItems.map((item) => ({
        alt: item.title,
        id: item.id,
        src: item.image,
      }))}
      isAuction={isAuction}
      isPreorder={isPreOrderFlow}
      numberOfDraws={orderedItems.length}
      status={
        redirectReturn.status === 'confirming' ? 'confirming' : 'confirmed'
      }
      winUpTo={maxQuantity}
    />
  );
};
